export default __webpack_public_path__ + "static/media/Supermercados Now.a4013f17.svg";